(function() {
  if (!document.querySelector('.tp-portfolio-page')) return;
  var info = document.querySelector('.tp-portfolio-info');
  if (!info) return;
  var titleEl = info.querySelector('.tp-portfolio-info__title');
  var subtitleEl = info.querySelector('.tp-portfolio-info__subtitle');
  var titleText = titleEl ? titleEl.textContent : '';
  var subtitleText = subtitleEl ? subtitleEl.textContent : '';

  var intro = document.createElement('div');
  intro.className = 'tp-portfolio-intro';
  intro.innerHTML = '<div class="tp-portfolio-intro__content">' +
    '<h1 class="tp-portfolio-intro__title">' + titleText + '</h1>' +
    '<p class="tp-portfolio-intro__subtitle">' + subtitleText + '</p>' +
    '</div>';
  document.body.appendChild(intro);

  var slideshow = document.querySelector('.tp-portfolio-slideshow');
  var controls = document.querySelector('.tp-portfolio-controls');
  var infoBar = document.querySelector('.tp-portfolio-info');
  if (slideshow) slideshow.style.opacity = '0';
  if (controls) controls.style.opacity = '0';
  if (infoBar) infoBar.style.opacity = '0';

  function enterSlideshow() {
    intro.classList.add('tp-portfolio-intro--exit');
    if (slideshow) { slideshow.style.transition = 'opacity 0.6s ease'; slideshow.style.opacity = '1'; }
    if (controls) { controls.style.transition = 'opacity 0.6s ease 0.3s'; controls.style.opacity = '1'; }
    if (infoBar) { infoBar.style.transition = 'opacity 0.6s ease 0.3s'; infoBar.style.opacity = '1'; }
    setTimeout(function() {
      if (intro.parentNode) intro.parentNode.removeChild(intro);
    }, 800);
  }

  setTimeout(enterSlideshow, 1500);

  var grid = document.querySelector('.tp-portfolio-grid');
  var description = document.querySelector('.tp-portfolio-description');

  /* Add text icon button to controls */
  if (controls) {
    var textBtn = document.createElement('button');
    textBtn.className = 'tp-portfolio-toggle';
    textBtn.setAttribute('data-view', 'text');
    textBtn.setAttribute('aria-label', 'Text');
    textBtn.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M4 6h16M4 12h16M4 18h10"></path></svg>';
    controls.appendChild(textBtn);
  }

  function switchView(view) {
    document.body.classList.remove('tp-grid-active', 'tp-text-active');
    if (slideshow) slideshow.classList.remove('tp-portfolio-view--active');
    if (grid) grid.classList.remove('tp-portfolio-view--active');
    if (description) description.classList.remove('tp-portfolio-view--active');

    if (view === 'grid') {
      document.body.classList.add('tp-grid-active');
      if (grid) grid.classList.add('tp-portfolio-view--active');
    } else if (view === 'text') {
      document.body.classList.add('tp-text-active');
      if (description) description.classList.add('tp-portfolio-view--active');
    } else {
      if (slideshow) slideshow.classList.add('tp-portfolio-view--active');
    }
    window.scrollTo(0, 0);
  }

  var toggles = document.querySelectorAll('.tp-portfolio-toggle');
  toggles.forEach(function(btn) {
    btn.addEventListener('click', function() {
      switchView(btn.getAttribute('data-view'));
    });
  });
})();
